import Vue from 'vue/dist/vue.js'

export default Vue.extend({
  data() {
    return {
      mood: null,
  
    }
  },
  created() {
    this.setMood(this.params)
  },
  methods: {
    refresh(params) {
      this.params = params
      this.setMood(params)
    },

    setMood(params) {
      this.mood = params.value
     
    },
  },
  template: `<div>
    <img :src="params.value" />
  </div>`,
})
